import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { Jumbotron } from 'react-bootstrap'
import { HardDriveUpload, LoaderCircle } from 'lucide-react'

export const UploadingLabel = () => <label>Uploading spreadsheet data...</label>
export const ValidatingLabel = () => <label>Validating spreadsheet data...</label>
export const ChooseFileLabel = ({ input }) => (
  <label htmlFor={input} data-testid="chooseFileLabel">
    <strong>Choose a file</strong> or drag it here.
  </label>
)

export const FileTypeMessage = ({ accept, show }) => {
  if (!show) return null
  return (
    <span data-testid="fileTypeMessage">
      File type must be one of <strong>{accept.join(', ')}</strong>
    </span>
  )
}

export const RowCounter = ({ type, count }) => {
  if (count <= 0) return null
  return (
    <span data-testid="rowCounter">
      <strong>{count}</strong> {type} row{count > 1 && 's'}
    </span>
  )
}

const iconProps = {
  size: 104,
  style: {
    color: '#0c3c65',
  },
}

const Metadata = ({
  totalRows,
  invalidRows,
  isIdle,
  isValidating,
  isReady,
  isUploading,
  isDragging,
  accept,
  fileInputId,
}) => {
  const jumboClasses = cn({ 'is-dragover': isDragging })

  return (
    <Jumbotron className={jumboClasses} data-testid="jumbotron">
      <div className="status-icon">
        {(isUploading || isValidating) && (
          <LoaderCircle
            size={iconProps.size}
            style={{ ...iconProps.style, animation: 'spin 2s infinite linear' }}
          />
        )}
        {(isIdle || isReady) && <HardDriveUpload {...iconProps} />}
      </div>
      <div className="metadata">
        <p>
          {(isIdle || isReady) && <ChooseFileLabel input={fileInputId} />}
          {isValidating && <ValidatingLabel />}
          {isUploading && <UploadingLabel />}
        </p>
        <p>
          <FileTypeMessage accept={accept} show={totalRows <= 0} />
          <RowCounter type="total" count={totalRows} />
          <RowCounter type="invalid" count={invalidRows} />
        </p>
        <p>
          Requires <strong>Agency Code</strong> in column 1 and{' '}
          <strong>Email Address</strong> in column 2. Header row will not be uploaded. If
          uploading an excel spreadsheet, data must be in the first worksheet of the first
          workbook.
        </p>
      </div>
    </Jumbotron>
  )
}

Metadata.propTypes = {
  totalRows: PropTypes.number,
  invalidRows: PropTypes.number,
  isIdle: PropTypes.bool,
  isValidating: PropTypes.bool,
  isReady: PropTypes.bool,
  isUploading: PropTypes.bool,
  isDragging: PropTypes.bool,
  accept: PropTypes.arrayOf(PropTypes.string),
  fileInputId: PropTypes.string,
}

export default Metadata
